import { render, staticRenderFns } from "./GoosdCanItem.vue?vue&type=template&id=f3b31036&scoped=true&"
import script from "./GoosdCanItem.vue?vue&type=script&lang=ts&"
export * from "./GoosdCanItem.vue?vue&type=script&lang=ts&"
import style0 from "./GoosdCanItem.vue?vue&type=style&index=0&id=f3b31036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b31036",
  null
  
)

export default component.exports